import SingleChat from "./components/SingleChat";
import { BsPencilSquare } from "react-icons/bs";
import { FiSearch } from "react-icons/fi";
import Chat from "./components/Chat";
import Card from "components/card";
import React from "react";
const Messages = () => {
  const [open, setOpen] = React.useState(false);
  const [selectedChat, setSelectedChat] = React.useState({
    name: "Dr. Sarah Chen (Mentor)",
    active: true
  });
  React.useEffect(() => {
    if (open && window.innerWidth < 800)
      document.documentElement.style.overflow = "hidden";
    else document.documentElement.style.overflow = "unset";
  });
  return (
    <div className="mt-[80px] flex w-full grid-cols-10 flex-col gap-5 md:mt-[20px] lg:mt-6 lg:min-h-[85vh] lg:flex-row">
      <div className="w-full lg:w-[35%]">
        <Card extra={"w-full h-full p-4"}>
          {/* search */}
          <div className="flex w-full items-center gap-2">
            <div className="flex h-[42px] w-full items-center rounded-full bg-lightPrimary text-navy-700 dark:bg-navy-900 dark:text-white ">
              <p className="pl-3 pr-2 text-xl">
                <FiSearch className="h-4 w-4 text-gray-400" />
              </p>
              <input
                type="text"
                placeholder="Search..."
                className="block h-full w-full rounded-full bg-lightPrimary text-sm font-medium text-navy-700 outline-none placeholder:!text-gray-400 dark:bg-navy-900 dark:text-white dark:placeholder:!text-white sm:w-fit"
              />
            </div>
            <button className="flex items-center justify-center rounded-full bg-brand-500 p-[12px] text-base font-medium text-white transition duration-200 hover:bg-blue-700 active:bg-blue-700 dark:bg-brand-400 dark:hover:bg-brand-300 dark:active:opacity-90">
              <BsPencilSquare />
            </button>
          </div>
          {/* messages */}
          <div className="mt-4">
            <div onClick={() => {
              setSelectedChat({
                name: "Dr. Sarah Chen (Mentor)",
                active: true
              });
              setOpen(true);
            }}>
              <Chat
                active={true}
                name="Dr. Sarah Chen (Mentor)"
                time="09:00 PM"
                message="Thank you for setting up such an amazing platform!"
              />
            </div>
            <div onClick={() => {
              setSelectedChat({
                name: "Alex Rodriguez (Mentee)",
                active: false
              });
              setOpen(true);
            }}>
              <Chat
                active={false}
                name="Alex Rodriguez (Mentee)"
                time="08:45 PM"
                message="Can you help me find a mentor in data science?"
              />
            </div>
            <div onClick={() => {
              setSelectedChat({
                name: "Jennifer Kim (Mentor)",
                active: true
              });
              setOpen(true);
            }}>
              <Chat
                active={true}
                name="Jennifer Kim (Mentor)"
                time="02:30 PM"
                message="Thank you for approving my mentor application!"
              />
            </div>
            <div onClick={() => {
              setSelectedChat({
                name: "Michael Brown (Mentee)",
                active: false
              });
              setOpen(true);
            }}>
              <Chat
                last
                active={false}
                name="Michael Brown (Mentee)"
                time="11:15 AM"
                message="I wanted to share feedback about my mentoring experience"
              />
            </div>
          </div>
        </Card>
      </div>
      <div className="w-full lg:w-[64.5%]">
        <SingleChat open={open} onClose={() => setOpen(false)} selectedChat={selectedChat} />
      </div>
    </div>
  );
};

export default Messages;
